<template>
    <div id="filters" class="wrap">
        <div class="search-container">
            <div class="tri" style="position: relative">
                <i class="icon-custom"></i>
                <input
                    type="text"
                    class="search"
                    :placeholder="placeholderFilter"
                    v-model="searchingBar"
                    @input="emitString"
                >
                <div class="reset-button">
                    <i class="fas fa-times" @click="resetSearch"></i>
                </div>
            </div>
        </div>
        <div class="buttons-container">
            <a v-if="gotFilter === true" href="javascript: void 0" class="btn active-filter" :class="(filterActive) ? 'on' : ''" @click="toggleFilterStatus" style="line-height: 18px;">
                <i class="icon-valid"></i>
                {{ filterText }}
            </a>
            <a href="javascript:void(0)"
               class="btn active-filter"
               v-if="isBouteille"
               :class="{ on: showMine }"
               @click="toggleShowMine"
               style="line-height: 18px;">
                <i class="icon-valid"></i>
                Mes bouteilles
            </a>
        </div>
    </div>
</template>

<script>

import History from '../../js/core/History'

export default {
    data() {
        return {
            searchingBar: '',
            filterActive: true,
            showMine: false,
        }
    },
    props: {
        gotFilter: Boolean,
        filterText: {
            type: String,
            default: '',
            required: false
        },
        isBouteille: false,
        placeholderFilter : String,
        typeHistory: String
    },
    methods: {
        async emitString() {
            await this.$emit('searchBarChanged', [this.searchingBar])
            if(typeof this.typeHistory !== "undefined") {
                await History.setHistory(this.typeHistory,
                    { 'text' : this.searchingBar,
                        'options' : { 'active' : this.filterActive}
                    }
                );
            }
        },

        toggleShowMine() {
            this.showMine = !this.showMine;
            this.$emit('toggleMine', this.showMine);

            if (typeof this.typeHistory !== "undefined") {
                History.setHistory(this.typeHistory, {
                    text: this.searchingBar,
                    options: {
                        active: this.filterActive,
                        showMine: this.showMine
                    }
                });
            }
        },

        toggleFilterStatus() {
            if(this.filterActive === true){
                this.filterActive = false;
                this.$emit('filterValChanged',this.filterActive)
            } else {
                this.filterActive = true;
                this.$emit('filterValChanged',this.filterActive)
            }

            if(typeof this.typeHistory !== "undefined") {
                History.setHistory(this.typeHistory,
                    { 'text': this.searchingBar,
                        'options' : { 'active' : this.filterActive}
                    }
                );
            }
        },
        resetSearch() {
            if(typeof this.typeHistory !== "undefined") {
                History.clearHistory(this.typeHistory, 'text');
            }
            this.searchingBar = '';
            this.$emit('searchBarChanged', [this.searchingBar]);
        }
    },
    async mounted() {
        if (typeof this.typeHistory === 'undefined') return;

        const history = await History.getHistory(this.typeHistory);

        if (!history) return;

        if (typeof history.text !== 'undefined') {
            this.searchingBar = history.text;
            this.$emit('searchBarChanged', [this.searchingBar]);
        }

        if (history.options) {
            if (typeof history.options.active !== 'undefined') {
                this.filterActive = history.options.active;
                this.$emit('filterValChanged', this.filterActive);
            }

            if (typeof history.options.showMine !== 'undefined') {
                this.showMine = history.options.showMine;
                this.$emit('toggleMine', this.showMine);
            }
        }
    }

}

</script>

<style>
#filters {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 10px;
}

.search-container {
    width: 100%;
}

.search-container .tri {
    background-color: #ddd;
    height: 50px;
    border-radius: 5px;
    position: relative;
    width: 100%;
}

.search-container .tri input {
    background-color: transparent;
    font-style: italic;
    position: relative;
    color: #999;
    width: 100%;
    padding-top: 0;
    border: 0 none;
    height: auto;
    padding-left: 50px;
    padding-right: 50px;
}

.search-container .tri i.icon-custom {
    position: absolute;
    -webkit-transform: translateY(-50%) rotate(-90deg);
    transform: translateY(-50%) rotate(-90deg);
    left: 10px;
    top: 50%;
    pointer-events: none;
    font-size: 3rem;
    color: #bbb;
}

.buttons-container {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: center;
}

.buttons-container a {
    position: relative;
    padding-left: 40px;
    padding-right: 10px;
    background-color: #e2e2e2;
    color: #999;
    border-radius: 5px;
    max-width: 200px;
    text-align: center;
    flex: 1;
}

.buttons-container a i {
    position: absolute;
    left: 10px;
    color: #999;
    font-size: 2.1rem;
}

.buttons-container a.on {
    background-color: #86bc24;
    color: #fff;
}

.buttons-container a.on i {
    color: #fff;
}

.reset-button {
    position: absolute;
    right: 0;
    height: 50px;
    width: 50px;
}

.reset-button i {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #999 !important;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// FilterBar.vue?35ddf786